// Timezone-safe date helpers.
// JS's `new Date("YYYY-MM-DD")` parses as UTC midnight, which shifts to the
// previous day in negative UTC offsets (e.g. America/Chicago). Use these
// helpers for any date-only string coming from the backend.

export function parseLocalDate(input) {
  if (!input) return null;
  const s = String(input).trim();
  // Date-only "YYYY-MM-DD" — construct in local time
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  if (m) {
    return new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
  }
  // Full ISO timestamp or anything else — let JS parse it
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}

export function formatLocalDate(input, opts) {
  const d = parseLocalDate(input);
  if (!d) return "";
  return d.toLocaleDateString(undefined, opts);
}
